/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gradelevel1Inputs */

const en__field_gradelevel1 = /** @type {(inputs: _Field_Gradelevel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade Level`)
};

const de__field_gradelevel1 = /** @type {(inputs: _Field_Gradelevel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassenstufe`)
};

/**
* | output |
* | --- |
* | "Grade Level" |
*
* @param {_Field_Gradelevel1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_gradelevel1 = /** @type {((inputs?: _Field_Gradelevel1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gradelevel1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_gradelevel1(inputs)
	return de__field_gradelevel1(inputs)
});
export { _field_gradelevel1 as "_field_gradeLevel" }